import {Component} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {EnvironmentService} from '../../services/environment.service';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {Merchant} from '../../models/merchant.model';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

declare var $: any;
declare var Snackbar: any;

@Component({
  selector: 'app-affiliate-merchants',
  templateUrl: './affiliate-merchants.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrl: './affiliate-merchants.component.scss'
})
export class AffiliateMerchantsComponent {

  merchants: Merchant[];
  subAccountType: any;
  subAccountGovId: any;
  loading: any;

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  lang: string;

  checkPermission() {
    this.route.queryParams.subscribe(params => {
      console.log('Params: ', params);
      let perms = this.env.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isMerchant = perms.isMerchant;
      this.isManager = perms.isManager;
      console.log('Permissions: ', perms);
    });
  }

  constructor(private loader: GlobalLoaderService,
              public env: EnvironmentService,
              private translator: TranslateService,
              private route: ActivatedRoute,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.lang = await firstValueFrom(this.translator.get('lang'));
    await this.loadResources();
    console.log('Data loaded');
    await this.loadData();
    this.loading = false;
    this.checkPermission();
    console.log('Permissions checked');
  }

  async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }

  private static compare(a: any, b: any) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
    return 0;
  }

  private async loadData() {
    let data = await this.api.getAffiliateMerchants();
    console.log('Data: ', data);
    this.merchants = data.affiliateMerchants;
    this.merchants.sort(AffiliateMerchantsComponent.compare);
    console.log('Invoices: ', this.merchants);
  }
}

